import { useEffect, useState } from "react";
import "./FlashcardReview.css";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
export default function FlashcardCard({ card, detailsState = {} }) {
  const [flipped, setFlipped] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  const navigate = useNavigate();

  const playAudio = (e) => {
  e.stopPropagation();
  if (!card.voiceUrl) return;

  if (!audioRef.current) {
    audioRef.current = new Audio(card.voiceUrl);
    audioRef.current.onended = () => setIsPlaying(false);
  }

  audioRef.current.currentTime = 0;
  audioRef.current.play();
  setIsPlaying(true);
};
  useEffect(() => {
  // khi đổi card / voiceUrl → reset audio
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current = null;
    setIsPlaying(false);
  }
}, [card.voiceUrl]);

  const openReviewDetails = (e) => {
    e.stopPropagation();
    navigate(`/review/details`, {
      state: {
        word: card.frontText,
        voiceUrl: card.voiceUrl,
        transliteration: card.transliteration,
        backText: card.backText,
        backgroundUrl: card.imageUrl,
        usageExample: card.usageExample,
        ...detailsState,
      }
    });
  };

  return (
    <div
      className={`flashcard-review ${flipped ? "flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      {/* FRONT */}
      <div className="front card shadow-sm">
        {card.imageUrl && (
          <img
            src={card.imageUrl}
            className="card-img-top"
            style={{
              height: "180px",
              objectFit: "cover",
              borderRadius: "12px 12px 0 0"
            }}
            alt=""
          />
        )}
        <div className="text-center mb-2">
              <div className="d-flex justify-content-center align-items-center gap-2">
                <h5 className="card-title text-primary fw-bold mb-0">
                  {card.frontText}
                </h5>

                <button
                  className="btn btn-link p-0"
                  onClick={openReviewDetails}
                  title="Open review focus"
                >
                  <i className="bi bi-bullseye" />
                </button>

                {card.voiceUrl && (
                  <button
                    className="btn btn-link p-0"
                    onClick={playAudio}
                    title="Play pronunciation"
                  >
                    <i
                      className={`bi audio-icon ${
                        isPlaying ? "bi-volume-up-fill" : "bi-volume-up"
                      }`}
                    />
                  </button>
                )}
              </div>

              {card.transliteration && (
                <span className="badge bg-info text-gray mt-1">
                  {card.transliteration}
                </span>
              )}
            </div>
      </div>

      {/* BACK */}
      <div className="back card shadow-sm">
        <div className="card-body text-center">
          <h5 className="fw-bold">{card.backText}</h5>
          {card.usageExample && (
            <p className="text-muted small mt-2">{card.usageExample}</p>
          )}
          <div className="text-muted small mt-2">Nhấp để quay lại</div>
        </div>
      </div>
    </div>
  );
}
